export enum EnumModeloInsercaoVenda {
    Simples,
    DetalhadoPreVenda,
    DetalhadoVenda,
    Detalhado,
}